const stages = [
  "Constructive",
  "Crossfire",
  "Rebuttal",
  "Summary",
  "Grand Crossfire",
  "Final Focus",
];

export default function RoundNotes({
  activeStage,
  notes,
  onStageChange,
  onNoteChange,
  teams,
  savedToAccount,
}) {
  return (
    <section
      className="notes-section section-reveal delay-one"
      data-testid="round-notes-section"
    >
      <div className="section-heading">
        <div>
          <p className="eyebrow">Live flow</p>
          <h2>Round notes</h2>
        </div>
        <span className="saved-hint" data-testid="local-save-status">
          {savedToAccount ? "Saved to your account" : "Saved on this device (this tab)"}
        </span>
      </div>
      <div
        className="stage-strip"
        role="tablist"
        aria-label="Speech stages"
        data-testid="speech-stage-tabs"
      >
        {stages.map((stage, index) => (
          <button
            key={stage}
            className={
              activeStage === stage ? "stage-button active" : "stage-button"
            }
            onClick={() => onStageChange(stage)}
            role="tab"
            aria-selected={activeStage === stage}
            data-testid={`speech-stage-${stage.toLowerCase().replaceAll(" ", "-")}-button`}
          >
            <span>{String(index + 1).padStart(2, "0")}</span>
            {stage}
          </button>
        ))}
      </div>
      <div className="note-pair">
        <div className="note-column pro-note">
          <label htmlFor="pro-notes">
            <span className="team-dot"></span>
            {teams.pro} · {activeStage}
          </label>
          <textarea
            id="pro-notes"
            value={notes[activeStage]?.pro || ""}
            onChange={(event) =>
              onNoteChange(activeStage, "pro", event.target.value)
            }
            placeholder="Claims, warrants, evidence, weighing…"
            data-testid="pro-notes-textarea"
          />
        </div>
        <div className="note-column con-note">
          <label htmlFor="con-notes">
            <span className="team-dot"></span>
            {teams.con} · {activeStage}
          </label>
          <textarea
            id="con-notes"
            value={notes[activeStage]?.con || ""}
            onChange={(event) =>
              onNoteChange(activeStage, "con", event.target.value)
            }
            placeholder="Responses, concessions, turns, weighing…"
            data-testid="con-notes-textarea"
          />
        </div>
      </div>
    </section>
  );
}
